module.exports = __webpack_public_path__ + "static/media/icon-graduate-student.eecdb9b2.svg";